import React from "react";

import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Alert } from "@mapmycustomers/ui";

import DealLockReason from "@app/enum/DealLockReason";
import dealLockMessages from "@app/util/deal/dealLockMessages";

interface DealLockNoteProps {
  className?: string;
  reason: DealLockReason | undefined;
}

const DealLockNote = ({ className, reason }: DealLockNoteProps) => {
  const intl = useIntl();

  if (!reason) {
    return null;
  }

  return (
    <Alert
      className={className}
      icon={<FontAwesomeIcon icon={faLock} />}
      message={intl.formatMessage(dealLockMessages[reason])}
      showIcon
      type="info"
    />
  );
};

export default DealLockNote;
